module.exports = __webpack_public_path__ + "static/img/ad.a4d85ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/ad.png
// module id = yZfx
// module chunks = 0